import styled from '@emotion/styled';

export const Copy = styled.ul`
  display: flex;
  flex-direction: column;
  gap: var(--whitespace-basic-06);
`;
